import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import { asyncSimpleModal, setPhoneFormat } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import Anchor from '../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import './OrderModifyDeliveryInfoModal.scss';

const OrderModifyDeliveryInfoModal = (props) => {
  const { data, isOpen, closeModal } = props;
  const { orderDeliveryModifyData } = data;
  const {
    recipient,
    cellPhone,
    addressLine1,
    addressLine2,
    message,
    createDate,
    modifyRecipient,
    modifyCellPhone,
    modifyAddressLine1,
    modifyAddressLine2,
    modifyMessage,
    modifyCreateDate,
  } = orderDeliveryModifyData;

  return (
    <Modal
      title="배송지 변경 이력 조회"
      isOpen={isOpen}
      width={700}
      height={300}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="order-modify-delivery-info-modal-wrap">
        {/*변경된 배송지 정보*/}
        <div className="order-delivery-modify-title">변경된 배송지 정보</div>

        <InfoTable className="order-delivery-modify-details">
          <thead>
            <tr>
              <th>일자</th>
              <th>수취인명</th>
              <th>수취인 연락처</th>
              <th>배송지</th>
              <th>배송 메세지</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{setDateFormat(modifyCreateDate, DATE_FORMAT.FULL_DASH_FORMAT)}</td>
              <td>{modifyRecipient}</td>
              <td>{setPhoneFormat(modifyCellPhone)}</td>
              <td>{`${modifyAddressLine1}, ${modifyAddressLine2}`}</td>
              <td>
                {modifyMessage ? (
                  <Anchor
                    color="primary"
                    isUnderLine
                    onClick={async () =>
                      await asyncSimpleModal({
                        title: '배송 메세지',
                        message: modifyMessage,
                      })
                    }
                    text="보기"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </InfoTable>

        {/*주문서 작성시 최초에 입력한 배송지 정보*/}
        <div className="order-delivery-title">주문서 작성시 최초에 입력한 배송지 정보</div>

        <InfoTable className="order-delivery-details">
          <thead>
            <tr>
              <th>일자</th>
              <th>수취인명</th>
              <th>수취인 연락처</th>
              <th>배송지</th>
              <th>배송 메세지</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{setDateFormat(createDate, DATE_FORMAT.FULL_DASH_FORMAT)}</td>
              <td>{recipient}</td>
              <td>{setPhoneFormat(cellPhone)}</td>
              <td>{`${addressLine1}, ${addressLine2}`}</td>
              <td>
                {message ? (
                  <Anchor
                    color="primary"
                    isUnderLine
                    onClick={async () =>
                      await asyncSimpleModal({
                        title: '배송 메세지',
                        message: message,
                      })
                    }
                    text="보기"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default OrderModifyDeliveryInfoModal;
